export const selectProps = (ignore, props) => props;
